<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="macroActivityMain">
          <project-asset
            v-on:project-changed="onProjectChange"
            v-on:vessel-changed="onVesselChange"
          ></project-asset>
          <v-card id="macroActivityCard">
            <v-card-title
              id="tableTitle"
              class="primary--text"
              style="font-size: 1.5em; padding: 20px"
              >{{ $t('nav.macroActMaster') }}</v-card-title
            >
            <v-data-table
              id="macroActivityTable"
              :headers="headers"
              :items="items"
              :items-per-page="-1"  
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: right">
                    {{ props.item.macroActivityID }}
                  </td>
                  <td style="text-align: left">{{ props.item.description }}</td>
                  <td style="text-align: left">
                    {{ props.item.projectName }}
                  </td>
                  <td style="text-align: left">
                    {{ props.item.vesselName }}
                  </td>
                  <td style="text-align: center">
                    <v-btn
                      id="btnDel"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      @click="deleteItemConfirm(props.item)"
                    >
                      <v-icon small color="primary">
                        mdi-delete
                      </v-icon>
                    </v-btn>
                    &nbsp;
                    <v-btn
                      id="btnEdit"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      :disabled="props.item.isDeleted"
                      @click="editItem(props.item)"
                    >
                      <v-icon small color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.macroActivityID"
                          :rules="[
                            () =>
                              !!editedItem.macroActivityID || requiredMessage
                          ]"
                          required
                          :readonly="editedIndex != -1"
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('nav.mActId') }}
                          </template></v-text-field
                        >
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          :rules="[
                            () => !!editedItem.projectId || requiredMessage
                          ]"
                          required
                          :items="projects"
                          item-text="Name"
                          item-value="Id"
                          v-model="editedItem.projectId"
                          :readonly="editedIndex != -1"
                          @change="onDlgProjectChange"
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('common.projectName') }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          :rules="[
                            () => !!editedItem.vesselId || requiredMessage
                          ]"
                          required
                          class="form-control"
                          :items="projectVessels"
                          item-text="Name"
                          item-value="Id"
                          v-model="editedItem.vesselId"
                          :readonly="editedIndex != -1"
                          @change="onDlgVesselChange"
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('common.asset') }}
                          </template>
                        </v-select></v-col
                      >

                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.description"
                          :rules="[
                            () => !!editedItem.description || requiredMessage
                          ]"
                          required
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('column.description') }}
                          </template></v-text-field
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{
                    $t('common.cancel')
                  }}</v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="save"
                    :disabled="!formIsValid"
                    >{{ $t('common.save') }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-fab-transition>
                <v-btn
                  id="btnAddmacroActivity"
                  color="primary"
                  dark
                  small
                  left
                  fab
                  @click="createItem()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>

              <v-btn class="ml-5" color="primary" @click="dialogImport = !dialogImport">
                <span class="text-caption">{{ $t("common.importFile") }}</span>
                <v-icon class="ml-3">mdi-microsoft-excel</v-icon>
              </v-btn>
              <v-btn class="ml-5" color="success" :href="exportExcel()" :disabled="disabledExportBtn" @click="mShowInfoMessage('Excel export requested')">
                <span class="text-caption">{{ $t("common.exportFile") }}</span>
                <v-icon class="ml-3">mdi-download</v-icon>
              </v-btn>
            </v-card-actions>

            <v-dialog v-model="dialogImport" persistent width="500">
              <v-card>
                <v-card-title
                  ><span class="headline">{{ $t("common.importFile") }}</span></v-card-title
                >

                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-select :rules="[() => !!importDlg.projectId || requiredMessage]" required :items="projects" item-text="Name" item-value="Id" v-model="importDlg.projectId" :readonly="editedIndex != -1" @change="onDlgImportProjectChange"
                        ><template v-slot:label>
                          <v-icon color="red" x-small>mdi-asterisk</v-icon>
                          {{ $t("common.projectName") }}
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select :rules="[() => !!importDlg.vesselId || requiredMessage]" required class="form-control" :items="projectVesselsImport" item-text="Name" item-value="Id" v-model="importDlg.vesselId" :readonly="editedIndex != -1" @change="onDlgimportVesselChange">
                        <template v-slot:label>
                          <v-icon color="red" x-small>mdi-asterisk</v-icon>
                          {{ $t("common.asset") }}
                        </template>
                      </v-select></v-col
                    >
                    <v-col cols="12">
                      <v-file-input v-model="file" accept=".xlsx" prepend-icon="mdi-microsoft-excel" label="Choose file to import" class="ma-2" @change="onFilePicked"></v-file-input>
                      <span v-if="showError" style="color: red">{{ $t("common.fileformaterror") }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-checkbox class="ml-3" v-model="emptyFolder">
                        <template v-slot:label>
                          {{ $t("common.emptyFolder") }}
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="warning" text @click="dialogImport = !dialogImport">{{ $t("common.cancel") }}</v-btn>

                  <v-btn color="primary" text :disabled="canUpload" @click="actionUpload()">{{ $t("common.import") }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import ProjectAsset from '../common/ProjectAsset'
import Vue from "vue";

export default {
  components: {
    'project-asset': ProjectAsset
  },
  data() {
    return {
      dialog: false,
      requiredMessage: this.$t('common.required'),
      headers: [
        {
          text: this.$t('nav.mActId'),
          align: 'right',
          sortable: true,
          value: 'macroActivityID',
          width: '15%'
        },
        {
          text: this.$t('column.description'),
          align: 'left',
          value: 'description'
        },
        {
          text: this.$t('common.projectName'),
          align: 'left',
          value: 'projectId'
        },
        {
          text: this.$t('common.asset'),
          align: 'left',
          value: 'vesselId'
        },
        {
          text: this.$t('column.actions'),
          align: 'center',
          value: 'opactions',
          sortable: false,
          width: '20%'
        }
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},

      selProjectId: 0,
      selVesselId: 0,
      dlgSelProjectId: null,
    
      dialogImport: false,
      showError: false,
      file: null,
      emptyFolder: false,
      selectedPvId: null,
      importDlg: {
        projectId: null,
        vesselId: null,
        selectedPvId: null,
      },
      excellink: "macro-activity/export?pvId=",
    };
  },
  computed: {
    ...mapGetters([
      'getProjectVesselMappings',
      
      'm_mActivity/getMacroActivities',
      'm_mActivity/getNextSeqCode',

      'm_project/getProjectNames',
      'm_project/getProjectsMap',
      'm_project/getProjectVesselIds',

      'm_vessel/getVesselNames',
      'm_vessel/getVesselsMap',

      'm_passet/getSelProjectId',
      'm_passet/getSelVesselId',
      'm_passet/getSelProjectVesselIds'
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('common.new') + ' ' + this.$t('nav.mAct')
        : this.$t('common.edit') + ' ' + this.$t('nav.mAct')
    },

    items() {
      return this['m_mActivity/getMacroActivities']
    },

    projects() {
      return this['m_project/getProjectNames'].filter((p) => p.VCount > 0)
    },

    vessels() {
      return this['m_vessel/getVesselNames']
    },

    projectVessels() {
      let pvIds = this['m_passet/getSelProjectVesselIds']
      if (this.dlgSelProjectId) {
        pvIds = this['m_project/getProjectVesselIds']
      }

      return this['m_vessel/getVesselNames'].filter((v) => {
        return (pvIds || []).indexOf(v.Id) !== -1
      })
    },

    projectVesselsImport() {
      let vessels = this.vessels;

      let pvIds = this["m_passet/getSelProjectVesselIds"];
      if (this.selectedPrj) {
        pvIds = this["m_project/getProjectVesselIds"];
      }

      return vessels.filter((v) => (pvIds || []).indexOf(v.Id) !== -1);
    },

    formIsValid() {
      return (
        this.editedItem.macroActivityID &&
        this.editedItem.description &&
        this.editedItem.projectId &&
        this.editedItem.vesselId
      )
    },

    canUpload() {
      return !this.file && !this.showError && !this.selectedPrj && !this.selectedVessel;
    },

    selectedPrj() {
      return this.importDlg.projectId;
    },

    selectedVessel() {
      return this.importDlg.vesselId;
    },
    
    disabledExportBtn() {
      return this.selVesselId ? (this.selProjectId ? false : true) : true;
    },

  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    selectedPrj: async function() {
      if (this.selectedPrj && this.selectedVessel) {
        await this.fetchProjectVesselMappings();
        this.importDlg.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selectedPrj && pv.vesselId == this.selectedVessel);
      }
    },

    selectedVessel: async function() {
      if (this.selectedPrj && this.selectedVessel) {
        await this.fetchProjectVesselMappings();
        this.importDlg.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selectedPrj && pv.vesselId == this.selectedVessel);
      }
    },

    selVesselId: async function() {
      if (this.selProjectId && this.selVesselId) {
        await this.fetchProjectVesselMappings();
        this.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selProjectId && pv.vesselId == this.selVesselId);
      } else this.selectedPvId = null;
    },

    selProjectId: async function() {
      if (this.selProjectId && this.selVesselId) {
        await this.fetchProjectVesselMappings();
        this.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selProjectId && pv.vesselId == this.selVesselId);
      } else this.selectedPvId = null;
    },
  },

  created() {
    this.selProjectId = this['m_passet/getSelProjectId']
    this.selVesselId = this['m_passet/getSelVesselId']
    this.refreshActivities()
    this.refreshNextSeqCode()
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader()
    })
  },

  methods: {
    ...mapActions([
      'm_mActivity/createMacroActivity',
      "m_mActivity/updateMacroActivityList",
      'm_mActivity/fetchMacroActivities',
      'm_mActivity/fetchNextMaxCode',
      'm_mActivity/deleteMacroActivity',
      'm_mActivity/updateMacroActivity',
      'm_project/fetchProjectVesselNames',
      'fetchProjectVesselMappings'
    ]),
    ...mapMutations(['mHideLongLoader', "mShowInfoMessage"] ),

    refreshActivities() {
      this['m_mActivity/fetchMacroActivities']({
        pId: this.selProjectId,
        vId: this.selVesselId
      })
    },

    onProjectChange(value) {
      this.selProjectId = value
      this.refreshActivities()
    },

    onVesselChange(value) {
      this.selVesselId = value
      this.refreshActivities()
    },

    onDlgProjectChange() {
      this.dlgSelProjectId = this.editedItem.projectId
      this.$log.debug('dlg project change', this.dlgSelProjectId)

      this['m_project/fetchProjectVesselNames'](this.dlgSelProjectId)
      this.refreshNextSeqCode()
    },

    onDlgVesselChange() {
      this.$log.debug('dlg vessel changed', this.editedItem.vesselId)
      if (!this.editedItem.projectId || !this.editedItem.vesselId) {
        return
      }

      this.refreshNextSeqCode()
    },

    onDlgImportProjectChange() {
      this["m_project/fetchProjectVesselNames"](this.selectedPrj);
    },

    onDlgimportVesselChange() {
      if (!this.selectedPrj || !this.selectedVessel) {
        return;
      }
    },

    refreshNextSeqCode(useDefVal) {
      if (this.editedIndex > -1) {
        return false
      }

      let pId = useDefVal ? this.selProjectId : this.editedItem.projectId
      let vId = useDefVal ? this.selVesselId : this.editedItem.vesselId

      this['m_mActivity/fetchNextMaxCode']({
        pId: pId,
        vId: vId
      }).then((nextCode) => {
        this.editedItem.macroActivityID = nextCode
        this.$nextTick(() => this.$forceUpdate())
      })
    },

    resetEntity(item) {
      this.dlgSelProjectId = null
      this['m_project/fetchProjectVesselNames'](this.dlgSelProjectId)

      this.defaultItem.projectId = this['m_passet/getSelProjectId']
      this.defaultItem.vesselId = this['m_passet/getSelVesselId']

      this.editedIndex = item ? this.items.indexOf(item) : -1
      this.editedItem = Object.assign({}, item || this.defaultItem)
    },

    editItem(item) {
      this.resetEntity(item)
      this.onDlgProjectChange()

      this.dialog = true
    },

    createItem() {
      this.resetEntity()

      if (this.defaultItem.projectId != null && this.defaultItem.selVesselId) {
        this.onDlgVesselChange()
      }

      this.refreshNextSeqCode();
      this.editedItem.macroActivityID = this['m_mActivity/getNextSeqCode']
      this.dialog = true
    },

    deleteItemConfirm(item) {
      this.resetEntity(item)

      var msg = this.editedItem.isDeleted ? 'warming.unlock' : 'warming.lock'

      this.$confirm(this.$t(msg) + this.$t('nav.mAct') + '?', {
        buttonTrueText: this.$t('common.ok'),
        buttonFalseText: this.$t('common.cancel'),
        color: 'warning',
        icon: 'warning',
        title: this.$t('common.warning'),
        width: 350,
        property: '$confirm'
      }).then(
        (res) =>
          res &&
          this['m_mActivity/deleteMacroActivity'](this.editedItem).then(
            this.refreshActivities
          )
      )
    },

    close() {
      this.$refs.form.resetValidation()
      this.dialog = false
      // this.refreshNextSeqCode(true)
    },

    save() {
      if (~this.editedIndex) {
        this['m_mActivity/updateMacroActivity'](this.editedItem).then(
          this.refreshActivities
        )
      }

      if (!~this.editedIndex) {
        this['m_mActivity/createMacroActivity'](this.editedItem).then(
          this.refreshActivities
        )
      }

      this.close()
    },

    exportExcel() {
      let pvId = "";
      try {
        pvId = this.selectedPvId ? this.selectedPvId[0].id : "";
      } catch (err) {
        pvId = "";
      }
      //let pvId = this.selectedPvId ? this.selectedPvId[0].id : "";
      if (this.excellink) return Vue.$hrefWithParams(this.excellink + pvId);
      return undefined;
    },

    onFilePicked() {
      this.$log.debug(this.file);
      let sp = this.file.name.split(".");
      if (this.file) {
        if (sp[1] != "xlsx") {
          this.showError = true;
        } else this.showError = false;
      }
    },

    async actionUpload() {

      let payload = {
        pvId: this.importDlg.selectedPvId[0].id,
        file: this.file,
        resetOldValues: this.emptyFolder,
      };

      await this["m_mActivity/updateMacroActivityList"](payload)
        .then(this.refreshActivities)
        .then((this.dialogImport = false));
    },
}
}
</script>

<style>
#macroActivitysTable {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
}
#macroActivitysTable header {
  font-weight: bold;
}
#macroActivitysCard {
  width: auto;
}
</style>